import { CognitoUser } from 'amazon-cognito-identity-js'
import * as React from 'react'

import { UserProfile } from '../../models'

export interface UserContextShape {
    user?: CognitoUser | null
    userProfile: UserProfile | null
    setUser: (user: CognitoUser) => void
    clearUser: () => void
    getUser: () => void
    getCognitoUser: () => void
    loading: boolean
}

export const UserContext = React.createContext<UserContextShape | undefined>(
    undefined,
)

export function useUser() {
    const context = React.useContext(UserContext)
    if (context === undefined) {
        throw new Error('useUserContext must be used inside UserProvider')
    }
    return context
}
